import { render, staticRenderFns } from "./BeModal.vue?vue&type=template&id=666befc2&"
import script from "./BeModal.js?vue&type=script&lang=js&"
export * from "./BeModal.js?vue&type=script&lang=js&"
import style0 from "./BeModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports